'use strict';

const processInclude = require('base/util');

$(document).ready(() => {
    processInclude(require('./experience/components/commerce_assets/rykiFrameScheduler'));
});
